import { render, staticRenderFns } from "./CanvasImport.vue?vue&type=template&id=e0301846"
import script from "./CanvasImport.vue?vue&type=script&lang=js"
export * from "./CanvasImport.vue?vue&type=script&lang=js"
import style0 from "./CanvasImport.vue?vue&type=style&index=0&id=e0301846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports